import React, { useState, useEffect } from 'react';
import { EVENTS } from '../utilities/CONSTANTS';

const useCategories = () => {
    const [categories, setCategories] = useState(window.categoriesAndFoldersMap);

    useEffect(() => {
        const handleCategoriesChange = () => setCategories(window.categoriesAndFoldersMap);
        window.addEventListener(EVENTS.CATEGORIES_LOADED, handleCategoriesChange);
        return () => window.removeEventListener(EVENTS.CATEGORIES_LOADED, handleCategoriesChange);
    });

    return categories;
};

export default useCategories;
